import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=5e689d71&scoped=true"
import script from "./EmptyComponent.vue?vue&type=script&lang=js"
export * from "./EmptyComponent.vue?vue&type=script&lang=js"
import style0 from "./EmptyComponent.vue?vue&type=style&index=0&id=5e689d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e689d71",
  null
  
)

export default component.exports